module.exports = __webpack_public_path__ + "img/word-bg2.3c50df40.png";